import { useMemo } from "react";
import { config } from "variables/config";
import MuiTable from "components/MuiTable";
import { Typography } from "@mui/material";
import { Badge } from "@chakra-ui/react";
import { formatNumber } from "utils";
import { NotFoundResults } from "components/Utils";
import useAppQuery from "hooks/useAppQuery";

export const Related = (props) => {
    const { data } = useAppQuery(
        props?.enterprise?.id
            ? `${config.app.api_url}/enterprises/${props?.enterprise?.id}/employers`
            : null
    );

    const datas = useMemo(
        () => [...(data?.data ?? [])].sort((a, b) => (a?.status > b?.status ? 1 : -1)),
        [data]
    );

    return (
        <div>
            <Typography>{props?.enterprise?.socialRaison}
            <Badge
         fontSize={13}
         rounded={5}
         padding={1}
         paddingInline={2}
         colorScheme="red"
         className="mx-1"
         >
         {formatNumber(datas?.length) || '--'}
       </Badge>
            </Typography>
          {datas?.length >0  ? <MuiTable hidePagiation={true} columns={props?.columns}
                rows={props?.rows(datas)} />
                :
                <NotFoundResults/>
                }
        </div>
        )
}
